import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UNLOCK_MENU_CURATION_TASK_DISHES_MUTATION } from '../graphql/mutations'
import { UNLOCK_MENU_CURATION_TASK_DISHES } from '../redux/action-types'

const useUnlockMenuCurationTaskDishesMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: UNLOCK_MENU_CURATION_TASK_DISHES_MUTATION,
        variables: { id },
        dispatch,
        action: UNLOCK_MENU_CURATION_TASK_DISHES,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUnlockMenuCurationTaskDishesMutation
